var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.01 2C17.5315 2.00552 22.0037 6.48512 22 12.0067C21.9963 17.5282 17.5182 22.0018 11.9967 22C6.47512 21.9982 2 17.5216 2 12C2.00331 6.47462 6.48462 1.99779 12.01 2ZM20 11.828C19.9527 7.42676 16.3589 3.89046 11.9575 3.91401C7.55603 3.93778 4.00046 7.51251 4.00046 11.914C4.00046 16.3155 7.55603 19.8902 11.9575 19.914C16.3589 19.9375 19.9527 16.4012 20 12V11.828ZM11 7H13V9H11V7ZM11 11H13L13 17H11L11 11Z",
    fill: "#A09FA9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/info-icon.f6f15a4011e1f4622643ae0771b65a3e.svg";
export { ForwardRef as ReactComponent };